module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "aut-int"
  }, [_vm._v("All the persons and events in this book are entirely imaginary. Nothing in it derlves from anything which ever happened.")]), _vm._v(" "), _c('p', {
    staticClass: "aut-ded"
  }, [_vm._v("Author’s dedication—")]), _vm._v(" "), _c('p', {
    staticClass: "aut-ded"
  }, [_vm._v("To my favorite detective,")]), _vm._v(" "), _c('p', {
    staticClass: "aut-ded"
  }, [_vm._v("CARL BRANDT")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db3d969","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Ded.vue
// module id = 72
// module chunks = 0